import cognito from "@/configuration/cognito";

export default [
  {
    path: "/logout",
    redirect: "/signout",
  },
  {
    path: "/signout",
    beforeEnter: async (to) => {
      sessionStorage.clear();
      await new Promise((resolve) => {
        cognito.signOut({
          onComplete: () => resolve(),
        });
      });
      return `/signin${to.query && to.query.cobrand ? `?cobrand=${to.query.cobrand}` : ""}`;
    },
    component: { render: () => null },
    meta: {
      preventInit: true,
    },
  },
];
